module.exports = __webpack_public_path__ + "static/media/hw_ta_16.6227698e.flv";